module.exports = __webpack_public_path__ + "media/theme/ico-comment-3-8d655273.png";